import { parsePhoneNumber } from 'libphonenumber-js';

/**
 * Monta o payload profissional para a API (e futura integração e-mail/CRM).
 * @param {object} values - valores já validados pelo formulário
 * @param {string} language - código BCP-47 (ex: pt-BR)
 */
export function buildContactPayload(values, language) {
  const nome = values.name.trim();
  const email = values.email.trim().toLowerCase();
  const mensagem = values.message.trim();
  const telefoneRaw = values.phone && String(values.phone).trim() ? String(values.phone).trim() : '';

  let ddi = null;
  let pais = null;
  let telefoneE164 = telefoneRaw || null;

  if (telefoneRaw) {
    try {
      const parsed = parsePhoneNumber(telefoneRaw);
      if (parsed) {
        ddi = parsed.countryCallingCode ? `+${parsed.countryCallingCode}` : null;
        pais = parsed.country || null;
        telefoneE164 = parsed.format('E.164');
      }
    } catch {
      // mantém string original se parse falhar (não deve ocorrer após validação)
    }
  }

  return {
    nome,
    email,
    departamento: values.department,
    telefone: telefoneE164,
    ddi,
    pais,
    mensagem,
    origem: 'site-contato',
    idioma: language || 'pt-BR',
    timestamp: new Date().toISOString()
  };
}

/**
 * Sanitização básica antes da validação (trim, mensagem sem tags HTML).
 */
export function sanitizeContactDraft(raw) {
  const stripTags = (s) => s.replace(/<[^>]*>/g, '');
  const phone =
    raw.phone == null || raw.phone === ''
      ? ''
      : String(raw.phone).trim();
  return {
    name: typeof raw.name === 'string' ? raw.name.trim() : '',
    email: typeof raw.email === 'string' ? raw.email.trim() : '',
    department: raw.department,
    phone,
    message: typeof raw.message === 'string' ? stripTags(raw.message).trim() : ''
  };
}
